import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./app/context/AuthContext";

import ClientLayout from "./app/layouts/ClientLayout";
import AdminLayout from "./app/layouts/AdminLayout";

import LoginPage from "./app/pages/LoginPage";
import ClientDashboard from "./app/pages/ClientDashboard";
import TransactionsPage from "./app/pages/TransactionsPage";
import UsersPage from "./app/pages/UsersPage";
import RequestsPage from "./app/pages/RequestsPage";
import HelpPage from "./app/pages/HelpPage";
import AdminDashboard from "./app/pages/AdminDashboard";
import ClientsPage from "./app/pages/ClientsPage";
import CredentialsPage from "./app/pages/CredentialsPage";
import ActivityMonitoringPage from "./app/pages/ActivityMonitoringPage";
import SystemLogsPage from "./app/pages/SystemLogsPage";
import InvoicePage from "./app/pages/InvoicePage";
import ValidationPage from "./app/pages/ValidationPage";

function Guard({ children, role }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/client"} replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          user ? (
            <Navigate to={user.role === "admin" ? "/admin" : "/client"} replace />
          ) : (
            <LoginPage />
          )
        }
      />

      {/* CLIENT ROUTES */}
      <Route
        path="/client"
        element={
          <Guard role="client">
            <ClientLayout />
          </Guard>
        }
      >
        <Route index element={<ClientDashboard />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="requests" element={<RequestsPage />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="invoices" element={<InvoicePage />} />
        <Route path="validate" element={<ValidationPage />} />
      </Route>

      {/* ADMIN ROUTES */}
      <Route
        path="/admin"
        element={
          <Guard role="admin">
            <AdminLayout />
          </Guard>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="requests" element={<RequestsPage />} />
        <Route path="credentials" element={<CredentialsPage />} />
        <Route path="activity" element={<ActivityMonitoringPage />} />
        <Route path="logs" element={<SystemLogsPage />} />
        <Route path="invoices" element={<InvoicePage />} />
        <Route path="validate" element={<ValidationPage />} />
      </Route>

      {/* FALLBACK */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
